"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var NavLink = (0, _styledComponents["default"])(_reactRouterDom.Link).attrs(function () {
  return {
    className: "nav-link"
  };
}).withConfig({
  displayName: "NavigationDropdownLink__NavLink",
  componentId: "euqah1-0"
})(["&&&{padding:8px 0.875rem;font-size:1.125rem;color:white !important;@media (min-width:768px){&&&{background-color:", ";}}&:hover{color:#dddddd !important;}}"], function (props) {
  return props.isActive ? props.theme["mlb-secondary-blue"] : null;
}).withComponent(function (_ref) {
  var isActive = _ref.isActive,
      props = _objectWithoutProperties(_ref, ["isActive"]);

  return _react["default"].createElement(_reactRouterDom.Link, props);
});

var NavigationDropdownLink = function NavigationDropdownLink(_ref2) {
  var toggleMobileNav = _ref2.toggleMobileNav,
      to = _ref2.to,
      name = _ref2.name,
      isActive = _ref2.isActive,
      _onClick = _ref2.onClick;
  return _react["default"].createElement("li", {
    className: "nav-item",
    id: "best-nav-dropdown-link"
  }, _react["default"].createElement(NavLink, {
    to: to,
    isActive: isActive,
    name: name,
    id: name,
    onClick: function onClick() {
      if (toggleMobileNav) {
        toggleMobileNav(false);
      }

      if (_onClick) {
        _onClick();
      }
    }
  }, name));
};

NavigationDropdownLink.propTypes = {
  isActive: _propTypes["default"].bool.isRequired,
  to: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].any.isRequired,
  toggleMobileNav: _propTypes["default"].func.isRequired,
  onClick: _propTypes["default"].func
};
NavigationDropdownLink.defaultProps = {
  name: "",
  to: "",
  isActive: false,
  onClick: function onClick() {}
};
var _default = NavigationDropdownLink;
exports["default"] = _default;